import { LoggerFactory } from "lego-gui-lib";
import React, { createContext, useContext, useEffect } from "react";
import { inject, IReactComponent } from "mobx-react";
import { Route, RouteComponentProps } from "react-router";

const log = LoggerFactory.create("ParentRoute");

export interface ParentRouteParams {
  path: string;
  dataSourceName: string;
  idField?: string;
}

export const ParentRoute = (props: ParentRouteParams) => {
  const idFieldName = props.idField || "id";
  return (
    <Route
      path={props.path}
      render={reload(props.dataSourceName, idFieldName)}
    />
  );
};

interface ParentContext {
  [dsName: string]: { link: string | null };
}
const parentContext = createContext({} as ParentContext);
const componentCache: {
  [name: string]: IReactComponent;
} = {};
export const reload = (dataSourceName: string, idField: string) => {
  return (props: RouteComponentProps<any>) => {
    const Comp =
      componentCache[dataSourceName] ||
      inject(dataSourceName)((injectProps: any) => {
        const dataSource = injectProps[dataSourceName];
        const context = useContext(parentContext);
        const match = injectProps.match;
        const idValue = match.params[idField];
        useEffect(() => {
          if (match.params !== undefined) {
            const link = dataSource.schema.link(match.params);

            if (!context[dataSourceName]) {
              context[dataSourceName] = { link: null };
            }

            if (idValue === "create") {
              log.debug(
                `clearing context for ${dataSourceName}, because you entered /create view`
              );
              context[dataSourceName].link = null;
              return;
            }

            const contextLink = context[dataSourceName].link;
            log.debug("props.match.params", match.params);
            log.debug("link", link);
            if (link !== contextLink) {
              log.debug(
                `updating parent context for ${dataSourceName}, because link changed from ${contextLink} to ${link}`
              );
              context[dataSourceName].link = link;
              dataSource.oneDataSource.clear();
              dataSource.oneDataSource.findOne(match.params);
            } else {
              log.debug(
                `not updating parent context for ${dataSourceName} because parent link did not change`
              );
            }
          }
          return () => {
            log.debug(
              "parent view unmounting with ds: ",
              dataSourceName,
              context[dataSourceName]
            );
            context[dataSourceName].link = null;
            dataSource.oneDataSource.clear();
          };
        }, [context, dataSource.oneDataSource, dataSource.schema, idValue]);

        return <></>;
      });

    if (!componentCache[dataSourceName]) {
      componentCache[dataSourceName] = Comp;
    }

    return <Comp {...props} />;
  };
};
